<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.notif-multiselect.multiselect .multiselect__tags {
  max-height: 100px !important;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1.5px solid #dde2ec;
  border-radius: 8px;
  padding: 6px 40px 6px 10px;
  min-height: 40px;
}
.notif-multiselect.multiselect .multiselect__placeholder {
  color: #b0bac9;
  font-size: 13px;
  margin-bottom: 0;
  padding-top: 0;
}
.notif-multiselect.multiselect .multiselect__tag {
  background: #389ad4;
  border-radius: 6px;
  font-size: 12px;
}
.notif-multiselect.multiselect .multiselect__tag-icon:after { color: #fff; }
.notif-multiselect.multiselect .multiselect__tag-icon:hover { background: #1E6FB8; }
.notif-multiselect.multiselect .multiselect__option--highlight { background: #389ad4; }
.notif-multiselect.multiselect--disabled .multiselect__select { background: transparent !important; }
.notif-multiselect.multiselect--disabled .multiselect__tags { pointer-events: none; background: #f8fafd; }
.notif-multiselect-clear { cursor: pointer; color: #c62828; font-size: 12px; font-weight: 600; &:hover { text-decoration: underline; } }
</style>

<style lang="scss" scoped>
.page-wrap {
  padding: 8px 0;
  font-family: 'Segoe UI', sans-serif;
}

.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  background: #eef2fb;
  border-bottom: 1px solid #dde4f5;
  gap: 10px;

  .panel-title {
    font-size: 13px;
    font-weight: 700;
    color: #389ad4;
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.panel-body {
  padding: 20px;
  background: #f8fafd;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.panel-footer {
  padding: 14px 20px;
  background: #fff;
  border-top: 1px solid #eef0f8;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* ── Field section card ── */
.field-section {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e8edf5;
  padding: 16px 16px 4px;

  .section-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #389ad4;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    gap: 6px;

    &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: #eef0f8;
    }
  }
}

/* ── Form fields ── */
.form-group {
  margin-bottom: 14px;

  label {
    font-size: 12px;
    font-weight: 600;
    color: #4a5568;
    margin-bottom: 5px;
    display: block;
  }

  .form-control {
    height: 40px;
    border: 1.5px solid #dde2ec;
    border-radius: 8px;
    font-size: 13px;
    color: #0d1b3e;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
      border-color: #389ad4;
      box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
      outline: none;
    }

    &.border-danger { border-color: #e53e3e !important; }
  }

  .text-danger { font-size: 11px; margin-top: 3px; display: block; }
}

/* ── Toggle switch ── */
.toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;

  label {
    font-size: 12px;
    font-weight: 600;
    color: #4a5568;
    margin: 0;
    cursor: pointer;
  }
}

/* ── Select-all row ── */
.select-all-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;

  .select-all-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #4a5568;
    cursor: pointer;

    input[type="checkbox"] {
      accent-color: #389ad4;
      width: 15px;
      height: 15px;
    }
  }
}

/* ── Buttons ── */
.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  background: #fff;
  border: 1.5px solid #dde2ec;
  color: #4a5568;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover { background: #f5f7fa; border-color: #c5cfe0; }
}

.btn-save {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 22px;
  background: #389ad4;
  color: #fff;
  border: none;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover { opacity: 0.9; }
}
</style>

<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <span class="panel-title">
          <i class="fa fa-bell"></i>
          {{ isEdit ? 'Edit Notification' : 'Create Notification' }}
        </span>
      </div>

      <!-- Body -->
      <div class="panel-body">

        <!-- Basic Info -->
        <div class="field-section">
          <div class="section-label"><i class="fa fa-tag"></i> Basic Info</div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Title / Subject <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="title" :class="errors['title'] ? 'border-danger' : ''" placeholder="e.g. System Maintenance Notice" />
                <span v-if="errors['title']" class="text-danger">{{ errors["title"][0] }}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Visible From <span class="text-danger">*</span></label>
                <input type="date" class="form-control" v-model="visible_from" :class="errors['visible_from'] ? 'border-danger' : ''" />
                <span v-if="errors['visible_from']" class="text-danger">{{ errors["visible_from"][0] }}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Visible Until <span class="text-danger">*</span></label>
                <input type="date" class="form-control" v-model="visible_until" :class="errors['visible_until'] ? 'border-danger' : ''" />
                <span v-if="errors['visible_until']" class="text-danger">{{ errors["visible_until"][0] }}</span>
              </div>
            </div>
          </div>

          <!-- Toggles -->
          <div class="row">
            <div class="col-md-3">
              <div class="toggle-row">
                <span class="switch">
                  <input type="checkbox" v-model="send_to_email" class="switch" id="switch-email" />
                  <label for="switch-email"></label>
                </span>
                <label for="switch-email">Send on Email</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="toggle-row">
                <span class="switch">
                  <input type="checkbox" v-model="is_urgent" class="switch" id="switch-urgent" />
                  <label for="switch-urgent"></label>
                </span>
                <label for="switch-urgent">
                  Mark as Urgent
                  <span style="margin-left:4px; font-size:10px; background:#fed7d7; color:#c53030; padding:1px 6px; border-radius:10px; font-weight:700;" v-if="is_urgent">URGENT</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Recipients -->
        <div class="field-section">
          <div class="section-label"><i class="fa fa-users"></i> Recipients</div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Service Providers <span class="text-danger">*</span></label>
                <multiselect
                  :value="clients"
                  :options="getserviceProviders"
                  :show-labels="true"
                  label="name"
                  track-by="id"
                  :close-on-select="false"
                  class="notif-multiselect"
                  :multiple="true"
                  placeholder="Select providers…"
                  @input="selectClients"
                />
                <span v-if="errors['clients']" class="text-danger">{{ errors["clients"][0] }}</span>
                <div class="select-all-row">
                  <label class="select-all-label">
                    <input type="checkbox" v-model="all_service_provider" @change="allServiceProviderSelected" />
                    Select All
                  </label>
                  <span class="notif-multiselect-clear" v-if="clients.length > 0" @click="clearAllServiceProvider()">Clear</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Service Locations <span class="text-danger">*</span></label>
                <multiselect
                  :value="locations"
                  :options="getSelectedProviderLocations"
                  :show-labels="true"
                  label="name"
                  track-by="id"
                  :multiple="true"
                  :close-on-select="false"
                  class="notif-multiselect"
                  placeholder="Select locations…"
                  @input="(val) => (locations = val)"
                />
                <span v-if="errors['locations']" class="text-danger">{{ errors["locations"][0] }}</span>
                <div class="select-all-row">
                  <label class="select-all-label">
                    <input type="checkbox" v-model="all_locations" @change="allLocationSelected" />
                    Select All
                  </label>
                  <span class="notif-multiselect-clear" v-if="locations.length > 0" @click="locations = []; all_locations = false;">Clear</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Description -->
        <div class="field-section">
          <div class="section-label"><i class="fa fa-file-text"></i> Message Body</div>
          <div class="form-group">
            <supporteditor
              v-model="details"
              api-key="no-api-key"
              :init="{
                license_key: 'gpl',
                height: 220,
                menubar: false,
                plugins: ['advlist autolink lists link image charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table paste code help wordcount'],
                toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
              }"
              tinymce-script-src="/tinymce/js/tinymce/tinymce.min.js"
            />
            <span v-if="errors['details']" class="text-danger">{{ errors["details"][0] }}</span>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="panel-footer">
        <button class="btn-back" @click="goBack()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
        <button class="btn-save" @click="createNotification()" :ref="isEdit ? 'kt_update_service' : 'store_s'">
          <i class="fa fa-check"></i>
          {{ isEdit ? 'Update Notification' : 'Save Notification' }}
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import Editor from "@tinymce/tinymce-vue";
import Multiselect from "vue-multiselect";
import {
  GET_SERVICE_PROVIDER_LIST,
  CREATE_UPDATE_NOTIFICATION,
  FETCH_NOTIFICATIONS,
  FETCH_SELECTED_LOCATIONS
} from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isEdit: false,
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "admin.dashboard" },
        { id: 2, title: "Notifications", route: "admin.notification" },
        { id: 3, title: "Create Notification", route: "" },
      ],
      details: "",
      title: "",
      send_to_email: false,
      is_urgent: false,
      loading_data: true,
      errors: [],
      clients: [],
      locations: [],
      visible_from: "",
      visible_until: "",
      all_service_provider: false,
      all_locations: false,
      id: 0,
    };
  },
  computed: {
    ...mapGetters(["getserviceProviders", "getSelectedProviderLocations"]),
  },
  components: {
    supporteditor: Editor,
    Multiselect,
  },
  created() {
    if (this.getserviceProviders.length === 0) this.getServiceProvider();
    if (this.$route.params.notification_id !== undefined) {
      this.fetchEditNotification(this.$route.params.notification_id);
      this.isEdit = true;
    }
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    if (this.isEdit) this.breadCrumbs[2].title = "Edit Notification";
  },
  mounted() {
    if (!this.isEdit) {
      this.visible_until = this.$moment(new Date()).add(7, "days").format("YYYY-MM-DD");
      this.visible_from = this.$moment(new Date()).format("YYYY-MM-DD");
    }
  },
  methods: {
    selectClients(selected) {
      this.clients = selected;
      this.all_service_provider = false;
      this.locations = this.locations.filter(loc => this.clients.some(c => c.id === loc.parent));
      this.getSelectedLocations(this.clients.map(e => e.id));
      this.all_locations = false;
    },
    clearAllServiceProvider() {
      this.clients = [];
      this.all_service_provider = false;
      this.locations = [];
      this.all_locations = false;
      this.getSelectedLocations([]);
    },
    getServiceProvider() {
      this.$store.dispatch(GET_SERVICE_PROVIDER_LIST).catch(err => { this.msg = err.error; });
    },
    getSelectedLocations(ids, selected_data = []) {
      this.loading_data = true;
      this.$store.dispatch(FETCH_SELECTED_LOCATIONS, ids).then(() => {
        if (this.isEdit && selected_data.length > 0) {
          setTimeout(() => {
            this.locations = this.getSelectedProviderLocations.filter(loc => selected_data.some(l => l.client === loc.id));
          }, 500);
        }
        this.loading_data = false;
      }).catch(err => { this.loading_data = false; this.msg = err.error; });
    },
    allServiceProviderSelected() {
      if (this.all_service_provider) {
        this.clients = this.getserviceProviders;
        this.all_locations = false;
        this.getSelectedLocations(this.clients.map(e => e.id));
      }
    },
    allLocationSelected() {
      if (this.all_locations) this.locations = this.getSelectedProviderLocations;
    },
    fetchEditNotification(notification_id) {
      this.loading_data = true;
      this.$store.dispatch(FETCH_NOTIFICATIONS, { id: notification_id }).then(res => {
        if (res.success) {
          const data = res.data[0];
          this.visible_until = data.visible_until;
          this.visible_from = data.visible_from;
          this.details = data.details;
          this.send_to_email = data.send_to_email;
          this.is_urgent = data.is_urgent;
          this.title = data.title;
          this.id = data.id;
          setTimeout(() => {
            this.clients = this.getserviceProviders.filter(p => data.clients.some(c => c.client === p.id));
            this.getSelectedLocations(this.clients.map(e => e.id), data.locations);
          }, 500);
        }
        this.loading_data = false;
      }).catch(err => { this.loading_data = false; this.msg = err.error; });
    },
    goBack() {
      this.$router.push({ name: "admin.notification" });
    },
    createNotification() {
      const payload = {
        title: this.title,
        details: this.details,
        visible_from: this.visible_from,
        visible_until: this.visible_until,
        send_to_email: this.send_to_email,
        is_urgent: this.is_urgent,
        clients: this.all_service_provider ? this.getserviceProviders.map(p => p.id) : this.clients.map(c => c.id),
        id: this.id,
        locations: this.all_locations ? this.getSelectedProviderLocations.map(l => l.id) : this.locations.map(l => l.id),
      };
      this.$store.dispatch(CREATE_UPDATE_NOTIFICATION, payload)
        .then(res => {
          this.$toastr.s(res.msg || "Notification saved successfully");
          this.$router.push({ name: "admin.notification" });
        })
        .catch(err => {
          this.errors = err.error || [];
          this.$toastr.e(err.msg || "Error saving notification");
        });
    },
  },
};
</script>
